import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import { medium, textMd } from "core/fontStyles";
import colors, { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

const ListItemStyled = styled.li`
    a {
        ${medium}
        ${textMd}
        display: inline-block;
        color: ${colors.secondary.orca};
        background-color: transparent;
        text-decoration: none;
        padding-bottom: ${convertPxToRem(4)};
        border-bottom-style: solid;
        border-bottom-width: ${convertPxToRem(1)};
        border-bottom-color: transparent;
    }

    /* Mobile Specific Styles */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        a {
            padding: ${convertPxToRem(12)} ${convertPxToRem(16)};
            border-bottom-color: ${colors.primary.diamond};

            &:hover {
                background-color: ${colors.accent.lightMode.dewdrop};
                text-decoration: none;
            }
        }

        &:last-child {
            a {
                border-bottom: none;
            }
        }
    }

    /* Tablet/Desktop Specific Styles */
    @media (min-width: ${breakpoints.tablet.rem}) {
        a {
            margin-bottom: ${convertPxToRem(16)};
            color: ${({ $isDarkMode }) =>
                $isDarkMode ? colors.primary.diamond : colors.secondary.orca};

            &:hover {
                border-bottom-color: ${({ $isDarkMode }) =>
                    $isDarkMode
                        ? colors.primary.diamond
                        : colors.secondary.orca};
            }

            ${focusStyles}
        }
    }
`;

// component
export const MenuItems = ({ links }) => {
    const { isDarkMode } = useSiteHeader();
    return (
        <ul>
            {Object.entries(links).map(([key, link]) => {
                const { hide, name, href, target } = link;
                if (hide) return null;
                return (
                    <ListItemStyled key={key} $isDarkMode={isDarkMode}>
                        <a href={href} target={target || "_self"}>
                            {name}
                        </a>
                    </ListItemStyled>
                );
            })}
        </ul>
    );
};

export default MenuItems;

// prop-types
MenuItems.propTypes = {
    links: PropTypes.object.isRequired
};
